import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import i18n from 'i18next';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Helper function to get current language
const getCurrentLanguage = () => {
  return i18n.language || 'ar';
};

// Helper function to get auth token
const getAuthToken = () => {
  const adminData = sessionStorage.getItem('adminkhadamat');
  if (adminData) {
    try {
      const parsed = JSON.parse(adminData);
      // البحث عن التوكن في أماكن مختلفة
      if (parsed.data?.token?.access_token) {
        const token = String(parsed.data.token.access_token);
        return token;
      }
      if (parsed.data?.access_token) return parsed.data.access_token;
      if (parsed.data?.token) return parsed.data.token;
      if (parsed.token) return parsed.token;
      if (parsed.result?.token) return parsed.result.token;
      if (parsed.user?.token) return parsed.user.token;
      return null;
    } catch (error) {
    }
  }
  return null;
};

// Fetch orders
export const fetchOrders = createAsyncThunk(
  'adminOrders/fetchOrders',
  async ({ page = 1, search = '', status = '', payment_status = '', delivery_status = '' }, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const params = new URLSearchParams();
      if (page) params.append('page', page);
      if (search) params.append('search', search);
      if (status) params.append('status', status);
      if (payment_status) params.append('payment_status', payment_status);
      if (delivery_status) params.append('delivery_status', delivery_status);

      const response = await axios.get(`${BASE_URL}/admin/admin/orders?${params}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept-Language': getCurrentLanguage(),
          'lang': getCurrentLanguage(),
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'فشل في جلب الأوردرات');
    }
  }
);

// Fetch order details
export const fetchOrderDetails = createAsyncThunk(
  'adminOrders/fetchOrderDetails',
  async (orderId, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const response = await axios.get(`${BASE_URL}/admin/admin/orders/${orderId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept-Language': 'ar',
          'lang': 'ar',
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'فشل في جلب تفاصيل الأوردر');
    }
  }
);

const initialState = {
  orders: [],
  orderDetails: null,
  pagination: {
    current_page: 1,
    total_pages: 1,
    per_page: 10,
    total_items: 0,
    next_page: null,
    prev_page: null
  },
  loading: false,
  error: null,
  detailsLoading: false,
  detailsError: null
};

const adminOrdersSlice = createSlice({
  name: 'adminOrders',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.detailsError = null;
    },
    clearOrderDetails: (state) => {
      state.orderDetails = null;
      state.detailsError = null;
    }
  },
  extraReducers: (builder) => {
    // Fetch orders
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload.data[0] || [];
        state.pagination = {
          current_page: action.payload.data[1]?.current_page || 1,
          total_pages: action.payload.data[1]?.total_pages || 1,
          per_page: action.payload.data[1]?.per_page || 10,
          total_items: action.payload.data[1]?.total_items || 0,
          next_page: action.payload.data[1]?.next_page,
          prev_page: action.payload.data[1]?.prev_page
        };
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Fetch order details
    builder
      .addCase(fetchOrderDetails.pending, (state) => {
        state.detailsLoading = true;
        state.detailsError = null;
      })
      .addCase(fetchOrderDetails.fulfilled, (state, action) => {
        state.detailsLoading = false;
        state.orderDetails = action.payload.data.data;
      })
      .addCase(fetchOrderDetails.rejected, (state, action) => {
        state.detailsLoading = false;
        state.detailsError = action.payload;
      });
  }
});

export const { clearError, clearOrderDetails } = adminOrdersSlice.actions;
export default adminOrdersSlice.reducer;
